<app-service-popup #servicePopup></app-service-popup>

<div class="page-container search-page-container">

  <div class="services-page search-page row justify-center nowrap gap-50">

    <div class="services-container search-section column gap-20">

      <div class="list-card" style="grid-area: testing-services">
        <div class="list-card-header">
          <h2>{{TestingServices.SPType}}</h2>
        </div>
        <ul class="list-card-body" style=" min-height: 340px;">
          <li class="list-card-item" *ngFor="let service of pagedTestingServices">
            <label for="{{service.Guid}}" class="checkbox-control">
              {{service.Name}} ({{service.Duration}}min)
              <input [(ngModel)]="service.Selected" (change)="selectService(service)" type="checkbox" id="{{service.Guid}}" />
              <span class="checkbox-indicator"></span>
              <span class="checkbox-indicator-container"></span>
            </label>
          </li>
        </ul>
        <app-pagination [items]="TestingServices.Services"
                        [itemsPerPage]="8"
                        (pageItems)="paginateTestingServices($event)">
        </app-pagination>
      </div>

      <div class="list-card" style="grid-area: other-services ">
        <div class="list-card-header">
          <h2>{{OtherServices.SPType}}</h2>
        </div>
        <ul class="list-card-body">
          <li class="list-card-item" *ngFor="let service of pagedOtherServices">
            <label for="{{service.Guid}}" class="checkbox-control">
              {{service.Name}} ({{service.Duration}}min)
              <input [(ngModel)]="service.Selected" (change)="selectService(service)" type="checkbox" id="{{service.Guid}}" />
              <span class="checkbox-indicator"></span>
              <span class="checkbox-indicator-container"></span>
            </label>
          </li>
        </ul>
        <app-pagination [items]="OtherServices.Services"
                        [itemsPerPage]="4"
                        (pageItems)="paginateOtherServices($event)">
        </app-pagination>
      </div>

      <div class="list-card" style="grid-area: fitting-services">
        <div class="list-card-header">
          <h2>{{FittingServices.SPType}}</h2>
        </div>
        <ul class="list-card-body">
          <li class="list-card-item" *ngFor="let service of pagedFittingServices">
            <label for="{{service.Guid}}" class="checkbox-control">
              {{service.Name}} ({{service.Duration}}min)
              <input [(ngModel)]="service.Selected" (change)="selectService(service)" type="checkbox" id="{{service.Guid}}" />
              <span class="checkbox-indicator"></span>
              <span class="checkbox-indicator-container"></span>
            </label>
          </li>
        </ul>
        <app-pagination [items]="FittingServices.Services"
                        [itemsPerPage]="4"
                        (pageItems)="paginateFittingServices($event)">
        </app-pagination>
      </div>

      <div class="list-card" style="grid-area: special-services">
        <div class="list-card-header">
          <h2>{{SpecialServices.SPType}}</h2>
        </div>
        <ul class="list-card-body" style=" min-height: 340px;">
          <li class="list-card-item" *ngFor="let service of pagedSpecialServices">
            <label for="{{service.Guid}}" class="checkbox-control">
              {{service.Name}} ({{service.Duration}}min)
              <input [(ngModel)]="service.Selected" (change)="selectService(service)" type="checkbox" id="{{service.Guid}}" />
              <span class="checkbox-indicator"></span>
              <span class="checkbox-indicator-container"></span>
            </label>
          </li>
        </ul>
        <app-pagination [items]="SpecialServices.Services"
                        [itemsPerPage]="8"
                        (pageItems)="paginateSpecialServices($event)">
        </app-pagination>
        <div class="list-card-header">
          <h2>{{AdminSpecialServices.SPType}}</h2>
        </div>
        <ul class="list-card-body" style=" min-height: 340px;">
          <li class="list-card-item" *ngFor="let service of pagedAdminSpecialServices">
            <label for="{{service.Guid}}" class="checkbox-control">
              {{service.Name}} ({{service.Duration}}min)
              <input [(ngModel)]="service.Selected" (change)="selectService(service)" type="checkbox" id="{{service.Guid}}" />
              <span class="checkbox-indicator"></span>
              <span class="checkbox-indicator-container"></span>
            </label>
          </li>
        </ul>
        <app-pagination [items]="AdminSpecialServices.Services"
                        [itemsPerPage]="8"
                        (pageItems)="paginateAdminSpecialServices($event)">
        </app-pagination>
      </div>
    </div>


    <div class="setup-options-form column gap-20">
      <div class="column">
        <div class="selected-setup-item row justify-space-between gap-20" *ngIf="selectedService && selectedService.Guid">
          <div class="title" style="text-wrap: nowrap;">
            <h3>{{selectedService.Name}}</h3>
          </div>
          <div class="column gap-20" style="width: auto;">
            <button type="button" class="custom-btn" (click)="View(selectedService)">View</button>
            <button type="button" class="custom-btn" (click)="Edit(selectedService)">Edit</button>
            <button type="button" class="custom-btn" (click)="Delete(selectedService)">Remove</button>
          </div>
          <!--<hr *ngIf="selectedProducts.length > 1" />-->
        </div>
      </div>
      <hr />
      <div class="column">
        <div class="row justify-space-between align-center gap-30">
          <div class="title align-center">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 0.642822V17.3571" stroke="#004D8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M0.642883 8.94849H17.3572" stroke="#004D8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>New Service</h3>
          </div>
          <button type="button" class="custom-btn" (click)="Add()">New</button>
        </div>
      </div>
      <hr />
      <div class="service-reports column gap-20">
        <div class="reports-section-header row align-center justify-space-between">
          <div class="title align-center">
            <svg width="25" height="50" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3571 0.785767H8.64284C7.77497 0.785767 7.07141 1.48932 7.07141 2.3572V3.14291C7.07141 4.01078 7.77497 4.71434 8.64284 4.71434H13.3571C14.225 4.71434 14.9286 4.01078 14.9286 3.14291V2.3572C14.9286 1.48932 14.225 0.785767 13.3571 0.785767Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M15.3214 2.35718H17.6786C18.0953 2.35718 18.4951 2.52274 18.7897 2.81743C19.0844 3.11214 19.25 3.51183 19.25 3.92861V19.6429C19.25 20.0596 19.0844 20.4594 18.7897 20.7541C18.4951 21.0487 18.0953 21.2143 17.6786 21.2143H4.32143C3.90465 21.2143 3.50496 21.0487 3.21026 20.7541C2.91557 20.4594 2.75 20.0596 2.75 19.6429V3.92861C2.75 3.51183 2.91557 3.11214 3.21026 2.81743C3.50496 2.52274 3.90465 2.35718 4.32143 2.35718H6.67857" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.85712 14.1429L10.2143 15.7143L14.9285 9.42859" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Reports</h3>
          </div>
          <button type="button" class="report-btn" (click)="onGenerateReport('Excel')">
            <svg width="25" height="50" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.28571 10.2144L11 14.9286L15.7143 10.2144" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11 0.785767V14.9286" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.5 21.2144H16.5" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download
          </button>
        </div>
        <div class="report-options" style=" text-wrap: nowrap;">
          <ul class="reports-list">
            <li class="w-100">
              <label for="AllServices" class="checkbox-control">
                Full List of Services
                <input type="radio" id="AllServices" [(ngModel)]="report" value="' '" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <li *ngFor="let SP_Type of SP_ServiceProviders" class="w-100">
              <label for="{{SP_Type.Guid}}" class="checkbox-control">
                {{SP_Type.SPType}}
                <input type="radio" id="{{SP_Type.Guid}}" [(ngModel)]="report" value="{{SP_Type.Guid}}" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</div>
